import api from '../../api/eventTrack'

const state = {
}

const actions = {
  trackCandidateViewJobDetail ({ commit }, params) {
    return api.trackCandidateViewJobDetail(params)
  },
  trackCandidateViewJobList ({ commit }, params) {
    return api.trackCandidateViewJobList(params)
  },
  trackCandidateShareJobDetail ({ commit }, params) {
    return api.trackCandidateShareJobDetail(params)
  },
  trackCandidateShareJobList ({ commit }, params) {
    return api.trackCandidateShareJobList(params)
  },
  trackCandidateShareCampaign ({ commit }, params) {
    return api.trackCandidateShareCampaign(params)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
